import { render } from "./CommentSearchView.vue?vue&type=template&id=4b670448"
import script from "./CommentSearchView.vue?vue&type=script&lang=js"
export * from "./CommentSearchView.vue?vue&type=script&lang=js"

import "./CommentSearchView.vue?vue&type=style&index=0&id=4b670448&lang=css"

import exportComponent from "C:\\Users\\AloneX\\taipeitest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__